import { styled } from "@mui/material/styles";
import MTypography from "@mui/material/Typography";
import { colors } from "@zapalacorp/tokens";

export const Container = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "100%",
}));

export const ContainerColumn = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  color: colors.gray500,
}));

export const Title = styled(MTypography)(() => ({
  fontWeight: 600,
  lineHeight: "28px",
  fontSize: "22px",
  fontFamily: "Manrope",
  textAlign: "center",
}));

export const Subtitle = styled(MTypography)(() => ({
  fontWeight: 400,
  lineHeight: "24px",
  fontSize: "16px",
  letterSpacing: "0.5px",
  fontFamily: "Manrope",
  textAlign: "center",
}));
